import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { ResolvableComponent } from '@ispm/core/decorators/resolvable-component.decorator';
import { IWidgetItem } from '@ispm/widgets/interfaces/widget-item.interface';
import { IdynamicFormItem } from '@ispm/dynamic-form/interfaces/IdynamicFormItem';
import {RouterManagerService} from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'ispm-patient-bar',
  templateUrl: './patient-bar.component.html',
  styleUrls: ['./patient-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
@ResolvableComponent(null, 'PatientBar')
export class PatientBarComponent implements OnInit, IWidgetItem {
  widgetUpdateValueCallback: (value) => void;
  config;
  data;
  @Input() patientId;
  /**
   * set patient bar widget config
   * @param _itemConfig
   */
  set widgetConfig(_itemConfig: IdynamicFormItem) {
    this.config = _itemConfig.widgetPayload;
  }

  /**
   * set patient bar widget config
   * @param widgetData
   */
  set widgetData(widgetData: any) {
    this.data = widgetData;
  }
  constructor(private routerManagerService: RouterManagerService) { }

  ngOnInit() {
    this.patientId = this.routerManagerService.parameters?.patientId;
  }

}
